// Copyright (c) 2015, Frappe Technologies Pvt. Ltd. and Contributors
// MIT License. See license.txt

frappe.provide("frappe.local");
frappe.local.lang = "sv";

if (frappe.local.lang == "sv") {
    $.extend(
        frappe._messages, {
        "Add to Cart": "Lägg till Kundkorg",
        "Add to Quote": "Lägg till Offert",
        "Available on backorder": "Tillgängligt på Restorder",
        "Attach": "Lägg till",
        "Brand": "Märke",
        "Cart is Empty": "Kundkorg är Tom",
        "Wishlist is empty!": "Önskelista är Tom",
        "Wishlist is empty !": "Önskelista är Tom",
        "Categories": "Kategori",
        "Discounts": "Rabbater",
        "Explore": "Välj",
        "Go to Cart": "Visa Kundkorg",
        "Go to Quote": "Visa Offert",
        "Item Code": "Artikel Kod",
        "Item Group":"Artikel Grupp",
        "Message": "Meddelande",
        "Next": "Nästa",
        "No products found": "Inga Artiklar hittades",
        "No searches yet.": "Inga Sökningar",
        "Out of stock": "Ej i Lager",
        "Out of Stock": "Ej i Lager",
        "Prev": "Föregående",
        "Previous": "Föregående",
        "Recent": "Senast Sökt",
        "Search for Products": "Sök Artiklar",
        "Stock Uom": "Lager Enhet",
        "Subject:Dialog": "Ämne",
        "Variant Of": "Variant Av",
        "Select Variant": "Välj Variant",
        "Product Details": "Artikel Detaljer",
        "Products": "Artiklar",
        "Recommended": "Rekommenderade Artiklar",
        "Profile Picture": "Profil Bild",
        "Select Variant for {0}": "Välj Variant för {0}",
        "Continue Selection": "Välj Variant",
        "{0} item found.": "{0} Artikel hittades.",
        "{0} items found.": "{0} Artiklar hittades.",
        "{0} days ago": "{0} dagar sedan",
        "{0} hours ago": "{0} timmar sedan",
        "Drag and drop files here or upload from": "Dra och släpp filer här eller ladda upp från",
        "Set Address": "Använd",
        "Select Address": "Välj Adress",
        "Shipping": "Leverans Adress",
        "Billing": "Faktura Adress",
        "State:Address": "Län",
        "Missing Values Required": "Saknade Värden Erfodras",
        "Following fields have missing values: <br><br><ul><li>{0}</li></ul>": "Följande Fält saknar värde: <br><br><ul><li>{0}</li></ul>",
        "Inavlid Values": "Felaktiga Värden",
        "Invalid Values": "Felaktiga Värden",
        "Following fields have invalid values: <br><br><ul><li>{0}</li></ul>": "456345636  fsa {0}",
        "Done": "Klar",
        "Clear": "Rensa",
        "Contact Us": "Kontakta Oss",
        "Full Name": "Namn",
        "Organization Name": "Organisation Namn",
        "Email": "E-post",
        "Phone Number": "Telefon",
        "Subject": "Ämne",
        "Send": "Skicka",
        "Clear values": "Rensa Värden",
        "Clear Values": "Rensa Värden",
        "Middle Name (Optional)": "Mellannamn (Valfri)",
        "Recomended": "Rekomenderat",
        "Write a Review": "Skriv Recension",
        "Headline": "Rubrik",
        "Overall Rating": "Betyg",
        "Your Review": "Recension",
        "New Address": "Ny Adress",
        "Available Offers": "Erbjudande",
        "Address Title": "Adress Titel",
        "Save": "Spara",
        "Address Line 1": "Adress Linje 1",
        "Address Line 2": "Adress Linje 2",
        "City/Town": "Ort",
        "State": "Län",
        "Country": "Land",
        "Address Type": "Adress Typ",
        "Postal Code": "Postnummer",
        "Phone": "Tel.",
        "Submit Review": "Spara",
        "Following fields have missing values:": "Följande fält saknar värde:",
        "Sweden": "Sverige",
        "Taxes": "Moms",
        "Thank you for the review": "Tack för recention",
        "Review Submitted": "Recention Sparad",
        }
    )
}
